module.exports = __webpack_public_path__ + "assets/img/ic-warning.721722fb.svg";